import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import changeAdminPassword from '../../services/changeAdminPassword';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import TimezoneSelect from "../../widgets/TimezoneSelect";

export default class UserSettings extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false
    }

    this.grid = 2;

    this.pageTitle = "User settings";

    this.tzRef = React.createRef();
    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    this.setState({});
  }

  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'username', numeric: false, disablePadding: true, label: 'Username' },
      { id: 'name', numeric: true, disablePadding: false, label: 'Name' },
      { id: 'surname', numeric: true, disablePadding: false, label: 'Surname' },
    ];

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />
          <TextInput name={'Old Password '} type={"password"} value={this.state.oldPassword} 
            onChange={(text) => { this.setState({oldPassword: text})}
          } />
          <TextInput name={'New Password '} type={"password"} value={this.state.newPassword} 
            onChange={(text) => { this.setState({newPassword: text})}
          } />
          <TextInput name={'Password confirm'} type={"password"} value={this.state.confirm} 
            onChange={(text) => { this.setState({confirm: text})}
          } />

          <TimezoneSelect ref={this.tzRef} name={'Timezone'} handleChange={(val) => {alert (this.tzRef.current.getValue())}}/> 

          <FixButton title={'Save'} callback={async () => {
              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });

              if (this.state.oldPassword == '') return;
              if (this.state.newPassword == '') return;
              if (this.state.confirm == '') return;
              if (this.state.newPassword != this.state.confirm) {alert ("The password confirm is not valid"); return;}

              let ret = await changeAdminPassword(username, token, this.state.oldPassword, this.state.newPassword);
              if (ret.success == false){
                alert ('Error changing password. Please check your data');
              }
              else {
                alert ('Password changed successfully');
                this.setState({
                  oldPassword: '',
                  newPassword: '',
                  confirm: '',
                });
              }
          }} />

        </LoadingOverlay>
      </>
    );
  }

}

